export enum FeatureToggles {
  YOUTUBE_STANDARD_ENABLED = 'youtubeStandardEnabled',
  // Creator Sourcing Agent
  CREATOR_SOURCING_AGENT_ENABLED = 'creatorSourcingAgentEnabled',
  // BRAND-9663/9664: opt-in "Generate Criteria" rerun option (BRAND-9605 tier
  // 2) — also gates BRAND-9664's run-1 inline-note submission, since that's
  // the run-1 half of the same rollout. Matches Platform's
  // generateRerunCriteriaEnabled toggle name (UnleashFeatureToggles, TRIBE-Platform).
  GENERATE_RERUN_CRITERIA_ENABLED = 'generateRerunCriteriaEnabled',
  // BRAND-9688: optional per-run YouTube "similar handle" discovery seed —
  // gates the input on DiscoveryRunForm's YouTube row. Matches Platform's
  // youTubeSimilarSearchEnabled toggle name (see the CSA design doc,
  // TRIBE-Creator-Sourcing-Agent docs/superpowers/specs/
  // 2026-09-09-youtube-similar-channel-sourcing-design.md).
  YOUTUBE_SIMILAR_SEARCH_ENABLED = 'youTubeSimilarSearchEnabled',
}
